import React from 'react'
import styles from './trx-action.module.scss'
import { ACTION_TYPE } from '@did/constants'
import { useDasBalanceContext } from '@did/das-app-context'
import { collapseString } from '@did/tools'
import { ITrxHistoryListInfo } from '@did/das-balance-types'

interface TrxActionProps {
  account: ITrxHistoryListInfo
}

const TrxAction: React.FC<TrxActionProps> = ({ account }) => {
  const { tt } = useDasBalanceContext()
  const getTrxAction = (action: number) => {
    let text = ''
    const accountName = collapseString(account.account, 4, 8)
    switch (action) {
      case ACTION_TYPE.withdraw:
        text = tt('Send')
        break
      case ACTION_TYPE.mergeRewards:
        text = tt('Rewards')
        break
      case ACTION_TYPE.list:
        text = tt('List {account}', { account: accountName })
        break
      case ACTION_TYPE.delist:
        text = tt('Delist {account}', { account: accountName })
        break
      case ACTION_TYPE.buyAccount:
        text = tt('Buy {account}', { account: accountName })
        break
      case ACTION_TYPE.sellAccount:
        text = tt('Sell {account}', { account: accountName })
        break
      case ACTION_TYPE.transferToTransit:
        text = tt('Activated')
        break
      case ACTION_TYPE.setReverseRecord:
        text = tt('Set Reverse Record')
        break
      case ACTION_TYPE.delReverseRecord:
        text = tt('Delete Reverse Record')
        break
      case ACTION_TYPE.dasBalanceRegisterOrRenew:
        text = tt('Register or Renew')
        break
      case ACTION_TYPE.renewal:
        text = tt('Renewal for DAS')
        break
      case ACTION_TYPE.makeOffer:
        text = tt('Make offer {account}', { account: accountName })
        break
      case ACTION_TYPE.editOfferAdd:
      case ACTION_TYPE.editOfferSub:
        text = tt('Edit offer {account}', { account: accountName })
        break
      case ACTION_TYPE.cancelOffer:
        text = tt('Cancel offer {account}', { account: accountName })
        break
      case ACTION_TYPE.acceptOffer:
        text = tt('Accept offer {account}', { account: accountName })
        break
      case ACTION_TYPE.offerAccepted:
        text = tt('Offer accepted {account}', { account: accountName })
        break
      case ACTION_TYPE.refundOfDeposit:
        text = tt('Refund of frozen CKB')
        break
      case ACTION_TYPE.orderRefund:
        text = tt('Refund')
        break
      case ACTION_TYPE.enableSubAccount:
        text = tt('Enable SubDIDs')
        break
      case ACTION_TYPE.createSubAccount:
        text = tt('Mint SubDIDs')
        break
      case ACTION_TYPE.accountRecycled:
      case ACTION_TYPE.accountRecycledRefund:
      case ACTION_TYPE.accountRecycledCrossRefund:
        text = tt('{account} recycled', { account: accountName })
        break
      case ACTION_TYPE.subAccountProfit:
        text = tt('From SuperDID')
        break
      case ACTION_TYPE.subAccountRenew:
        text = tt('SubDID Renew')
        break
      case ACTION_TYPE.accountAuctionRefund:
        text = tt('Refund of frozen CKB')
        break
    }
    return text
  }

  return (
    <span
      className={`${styles.trxAction} ${
        styles[`trxAction__action${account.action}`]
      }`}
    >
      {getTrxAction(account.action)}
    </span>
  )
}

export default TrxAction
